import { fetchSocialMediaSharesForAdminListingAPIPath } from "../links";

export async function fetchSocialMediaSharesForAdvocateListing({ postIDs }) {
  const queryParams = postIDs.map(id => `postIDs=${encodeURIComponent(id)}`).join('&');
  const url = `/api/social-media-shares?${queryParams}`;
  try {
    const res = await fetch(url);
    const data = await res.json();
    if (res.status >= 400) {
      return {
        error: data.Error,
      };
    }
    return { socialMediaShares: data.Data };
  } catch (e) {
    console.error("error while fetching social media shares", e);
    return {
      error: "Error while fetching social media shares. Please try again in sometime."
    };
  }
}

export async function deleteShare(csrfToken, shareID) {
  try {
    const res = await fetch(`/api/social-media-shares/${shareID}`, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': csrfToken
      }
    });
    if (res.status >= 400) {
      const data = await res.json();
      return {
        error: data.Error,
      };
    }
    return {};
  } catch (e) {
    console.error("error while deleting share", e);
    return {
      error: "Error while deleting share. Please try again in sometime."
    };
  }
}

export async function fetchSocialMediaSharesForAdminListing({ postVariationIDs, orgID, postIDs, limit, offset }) {
  const url = fetchSocialMediaSharesForAdminListingAPIPath(postIDs, postVariationIDs, orgID, limit, offset);
  try {
    const res = await fetch(url);
    const data = await res.json();
    if (res.status >= 400) {
      return {
        error: data.Error,
      };
    }
    return { socialMediaShares: data.Data };
  } catch (e) {
    console.error("error while fetching social media shares", e);
    return {
      error: "Error while fetching social media shares. Please try again in sometime."
    };
  }
}

export async function fetchSocialMediaShare({ socialMediaShareID, orgID }) {
  const url = `/api/admin/social-media-shares/${socialMediaShareID}?orgID=${orgID}`;
  try {
    const res = await fetch(url);
    const data = await res.json();
    if (res.status >= 400) {
      return {
        error: data.Error,
      };
    }
    return { share: data.Data };
  } catch (e) {
    console.error("error while fetching social media share", e);
    return {
      error: "Error while fetching social media share. Please try again in sometime."
    };
  }
}

export async function fetchSocialMediaShareByID({ shareID, orgID }) {
  const queryParams = new URLSearchParams()
  if (orgID) queryParams.append("orgID", orgID)
  try {
    const res = await fetch(`/api/social-media-shares/${shareID}?${queryParams.toString()}`)
    const data = await res.json()
    if (res.status >= 400) {
      return { error: data.Error }
    }
    return { share: data.Data }
  } catch (e) {
    console.error("error while fetching social media share", e)
    return { error: "Error while fetching social media share. Please try again in sometime." }
  }
}

export async function updateSocialMediaShare(csrfToken, shareID, { content, comment, medias, isMediaOverridden, scheduledAt }) {
  try {
    const res = await fetch(`/api/social-media-shares/${shareID}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({ content, comment, medias, isMediaOverridden, scheduledAt }),
    })
    const data = await res.json()
    if (res.status >= 400) {
      return { error: data.Error }
    }
    return { share: data.Data }
  } catch (e) {
    console.error("error while updating social media share", e)
    return { error: "Error while updating social media share. Please try again in sometime." }
  }
}
